import db from "../../jsonServer/db.json";

const stationTypesMap = db.station_types.reduce((acc, t) => {
  acc[t.id] = t;
  return acc;
}, {});

export function getStations({ id, station_type_id, _expand } = {}) {
  let results = db.stations;

  if (id) {
    const ids = Array.isArray(id) ? id : [id];
    results = results.filter((s) => ids.includes(s.id));
  }

  if (station_type_id) {
    const typeIds = Array.isArray(station_type_id)
      ? station_type_id
      : [station_type_id];
    results = results.filter((s) => typeIds.includes(s.station_type_id));
  }

  if (_expand === "station_type") {
    results = results.map((s) => ({
      ...s,
      station_type: stationTypesMap[s.station_type_id] || null,
    }));
  }

  return results;
}

export function getStationTypes() {
  return db.station_types;
}
